const translations = {
  ar: {
    welcome1: 'حياك الله...',
    welcome2: 'أنا مساعدك الافتراضي من لبيه ميوا، مهمتي الإجابة عن استفسارك وتقديم الدعم اللازم.',
    welcome3: 'يرجى الملاحظة أن هذه الخدمة تعتمد على تقنيات الذكاء الاصطناعي التوليدي، سيسعدنا دعمك في تقييم الإجابات لتساهم معنا في إثراء المحتوى وتطوير الخدمة.',
    startButton: 'بدء المحادثة',
    chooseLang: 'اختر اللغة (Choose Language)',
    beta: 'الإطلاق التجريبي',
    inputPlaceholder: 'ادخل استفسارك هنا ...',
    send: 'إرسال الرسالة',
    newSession: 'بدء محادثة جديدة',
    closeChat: 'إغلاق المحادثة',
    connectError: 'عذراً، فشل الاتصال بخدمة الدردشة. يرجى المحاولة مرة أخرى.',
    sendError: 'عذراً، فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',
    fileError: 'عذراً، فشل إرسال الملف. يرجى المحاولة مرة أخرى.',
    humanAgentJoined: 'تم انضمام موظف الدعم',
    humanAgentLeft: 'غادر موظف الدعم المحادثة',
    unsupportedFile: 'نوع الملف غير مدعوم. الأنواع المدعومة: صور، PDF، Word، Excel، نص.',
    fileTooLarge: 'حجم الملف كبير جداً. الحد الأقصى هو 10 ميجابايت.',
    dropFile: 'أفلت الملف هنا',
    attachFile: 'إرفاق صورة أو ملف',
    attachFileHint: 'إرفاق صورة أو ملف (أو اسحب وأفلت)',
    uploading: 'جاري الإرسال...',
    uploadFailed: 'فشل الإرسال',
    uploadSent: '✓ تم الإرسال',
    fileReceived: '📥 ملف مستلم',
    logoAlt: 'لبيه ميوا',
  },
  en: {
    welcome1: 'Welcome...',
    welcome2: 'I am your virtual assistant from Labeah Waseel. My mission is to answer your inquiries and provide the necessary support.',
    welcome3: 'Please note that this service relies on generative AI technologies. We would appreciate your support in evaluating responses to help enrich content and develop the service.',
    startButton: 'Start Conversation',
    chooseLang: 'Choose Language (اختر اللغة)',
    beta: 'Beta Version',
    inputPlaceholder: 'Enter your inquiry here...',
    send: 'Send message',
    newSession: 'Start a new conversation',
    closeChat: 'Close chat',
    connectError: 'Sorry, failed to connect to the chat service. Please try again.',
    sendError: 'Sorry, failed to send the message. Please try again.',
    fileError: 'Sorry, failed to send the file. Please try again.',
    humanAgentJoined: 'A support agent has joined',
    humanAgentLeft: 'The support agent has left the conversation',
    unsupportedFile: 'Unsupported file type. Supported types: images, PDF, Word, Excel, text.',
    fileTooLarge: 'The file is too large. The maximum size is 10 MB.',
    dropFile: 'Drop the file here',
    attachFile: 'Attach an image or file',
    attachFileHint: 'Attach an image or file (or drag and drop)',
    uploading: 'Sending...',
    uploadFailed: 'Failed to send',
    uploadSent: '✓ Sent',
    fileReceived: '📥 File received',
    logoAlt: 'Labeah Waseel',
  },
};

export function detectLanguage() {
  const lang =
    (typeof document !== 'undefined' && document.documentElement.lang) ||
    (typeof navigator !== 'undefined' && navigator.language) ||
    'ar';
  return String(lang).toLowerCase().includes('ar') ? 'ar' : 'en';
}

export function getTranslations(language) {
  return translations[language] || translations.ar;
}

export default translations;
